"use strict";
var distill;
(function (distill) {
    var datasets;
    (function (datasets) {
        var views;
        (function (views) {
            var createWizard1_origin;
            (function (createWizard1_origin) {
                let DatasetCreationMethod;
                (function (DatasetCreationMethod) {
                    DatasetCreationMethod["None"] = "None";
                    DatasetCreationMethod["Manual"] = "Manual";
                    DatasetCreationMethod["FormScreen"] = "FormScreen";
                    DatasetCreationMethod["DataSource"] = "DataSource";
                    DatasetCreationMethod["FileUpload"] = "FileUpload";
                })(DatasetCreationMethod || (DatasetCreationMethod = {}));
                class InitArgs {
                    constructor() {
                        this.wizardToken = '';
                        this.creationMethod = DatasetCreationMethod.None;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    $(function () {
                        bindEvents();
                        updateToolbar();
                    });
                }
                createWizard1_origin.init = init;
                function getParentButton(selector) {
                    return $(parent.document).find(selector);
                }
                function bindEvents() {
                    $(document).on('click', '.wizard-method-card', function () {
                        const method = $(this).data('method');
                        selectMethod(method);
                    });
                    getParentButton('#wizardNextBtn').on('click', function () {
                        submitForm();
                    });
                }
                function selectMethod(method) {
                    $('#CreationMethod').val(method);
                    $('.wizard-method-card').removeClass('active');
                    $(`.wizard-method-card[data-method="${method}"]`).addClass('active');
                    updateToolbar();
                    submitForm();
                }
                function updateToolbar() {
                    const $next = getParentButton('#wizardNextBtn');
                    const method = $('#CreationMethod').val();
                    if (method && method !== 'None') {
                        $next.removeClass('d-none');
                    }
                    else {
                        $next.addClass('d-none');
                    }
                }
                function submitForm() {
                    $('form')[0].submit();
                }
            })(createWizard1_origin = views.createWizard1_origin || (views.createWizard1_origin = {}));
        })(views = datasets.views || (datasets.views = {}));
    })(datasets = distill.datasets || (distill.datasets = {}));
})(distill || (distill = {}));
